// Dependencies
import { FC, MouseEventHandler } from "react";

// Components
import InfoItem from "~/components/Layout/InfoItem";
import { Choose, When } from "jsx-control-statements";
import { HashLoading, IconButton } from "~/components/Common";

// icons
import { ReactComponent as DeleteIcon } from "~/assets/icons/trash-can-regular.svg";
import { ReactComponent as EditIcon } from "~/assets/icons/pen-to-square-regular.svg";

// types
import { TQueryStatus, TTransactionData } from "~/types";

// utils
import { convertISOtoLocalTime, currencyFormat } from "~/utils";

// Styles
import {
  StyledItemText,
  StyledInfoLabel,
  StyledInfoAction,
  StyledInfoDetail,
  StyledInfoContent,
  StyledInfoWrapper,
  StyledItemCurrency,
} from "~/components/Layout/LayoutInfo/";
import { StyledErrorMessage } from "~/components/Layout";
import { StyledDeleteButton } from "./TransactionInfo.styled";

interface TransactionInfoProps {
  data: TTransactionData | undefined;
  error: string | undefined;
  status: TQueryStatus;
  currency: string;
  onEdit: MouseEventHandler;
  onDelete: MouseEventHandler;
}

const TransactionInfo: FC<TransactionInfoProps> = ({
  data,
  error,
  status,
  currency,
  onEdit,
  onDelete,
}) => {
  return (
    <StyledInfoWrapper>
      <StyledInfoLabel>Transaction Detail</StyledInfoLabel>
      <StyledInfoContent>
        <Choose>
          <When condition={status.isLoading}>
            <HashLoading />
          </When>
          <When condition={status.isError}>
            <StyledErrorMessage>{error}</StyledErrorMessage>
          </When>
          <When condition={status.isSuccess}>
            <StyledInfoAction>
              <StyledDeleteButton onClick={onDelete}>
                <DeleteIcon />
              </StyledDeleteButton>
              <IconButton onClick={onEdit}>
                <EditIcon />
              </IconButton>
            </StyledInfoAction>
            <StyledInfoDetail>
              <InfoItem
                label={"Amount"}
                data={
                  <StyledItemCurrency>
                    {currencyFormat(data?.amount, currency)}
                  </StyledItemCurrency>
                }
              />
              <InfoItem
                label={"Username"}
                data={<StyledItemText>{data?.username}</StyledItemText>}
              />
              <InfoItem
                label={"Category"}
                data={<StyledItemText>{data?.categoryName}</StyledItemText>}
              />
              <InfoItem
                label={"Note"}
                data={<StyledItemText>{data?.note}</StyledItemText>}
              />
              <InfoItem
                label={"Exclude from Report"}
                data={
                  <StyledItemText>
                    {data?.excludeFromReport ? "Yes" : "No"}
                  </StyledItemText>
                }
              />

              <InfoItem
                label={"Event name"}
                data={<StyledItemText>{data?.eventName}</StyledItemText>}
              />
              <InfoItem
                label={"Transaction date"}
                data={
                  <StyledItemText>
                    {convertISOtoLocalTime(data?.transactionDate)}
                  </StyledItemText>
                }
              />
            </StyledInfoDetail>
          </When>
        </Choose>
      </StyledInfoContent>
    </StyledInfoWrapper>
  );
};

export default TransactionInfo;
